import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const meta = {
  title: 'Thank You | Bagga International',
  meta: [
    { name: 'description', content: 'Thank you for your enquiry. We have received your message and will get back to you soon.' },
    { property: 'og:title', content: 'Thank You | Bagga International' },
    { property: 'og:description', content: 'Thank you for your enquiry. We have received your message and will get back to you soon.' },
    { property: 'og:image', content: '/images/site-default-og.jpg' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://baggainternational.com/thank-you' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'Thank You | Bagga International' },
    { name: 'twitter:description', content: 'Thank you for your enquiry. We have received your message and will get back to you soon.' },
    { name: 'twitter:image', content: '/images/site-default-og.jpg' }
  ],
  link: [
    { rel: 'canonical', href: 'https://baggainternational.com/thank-you' }
  ],
  style: [],
  script: [],
};

export default function ThankYou() {
  return (
    <HelmetProvider>
      <Helmet {...meta}></Helmet>
      <div className="container mx-auto px-4 py-16 text-center">
        <h1 className="text-4xl font-bold mb-4 text-green-600">Thank You!</h1>
        <p className="text-lg mb-4">Your enquiry has been submitted successfully.<br />We appreciate your interest and will get back to you soon.</p>
        <a href="/" className="inline-block mt-6 px-6 py-3 bg-green-500 text-white rounded-lg font-semibold hover:bg-green-600 transition">Back to Home</a>
      </div>
    </HelmetProvider>
  );
}
